import type { ReactNode } from "react";
import { Box, Chip, Tooltip } from "@mui/joy";
import type { SMSPlaceholderDefinition } from "../../../api/smsTemplates/SMSTemplate.typed";
import { colorTokens } from "../../../styles/globalStyles";

export function insertSMSPlaceholder(
  text: string,
  key: string,
  textarea: HTMLTextAreaElement | null,
): string {
  const token = `{{.${key}}}`;
  if (!textarea) return text + token;
  const start = textarea.selectionStart ?? text.length;
  const end = textarea.selectionEnd ?? text.length;

  return text.slice(0, start) + token + text.slice(end);
}

type SMSPlaceholderChipsProps = {
  placeholders: SMSPlaceholderDefinition[];
  canEdit: boolean;
  onInsert: (key: string) => void;
};

export function SMSPlaceholderChips(props: SMSPlaceholderChipsProps): ReactNode {
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
      {props.placeholders.map((d) => {
        const label = d.label?.trim() || d.key;
        const tip = d.description?.trim() || label;

        return (
          <Tooltip key={d.key} title={tip}>
            <Chip
              size="sm"
              variant="outlined"
              onClick={() => props.canEdit && props.onInsert(d.key)}
              disabled={!props.canEdit}
              sx={{
                borderColor: colorTokens.border.strong,
                fontSize: 12,
                cursor: props.canEdit ? "pointer" : "default",
              }}
            >
              {label}
            </Chip>
          </Tooltip>
        );
      })}
    </Box>
  );
}
